import { action, observable, makeObservable } from "mobx";
import { Messages } from "../models/Messages/Message";
import ChatAPI from "../api/ChatAPI";

export class ChatStore {
  ChatAPI: ChatAPI;
  limit: number;
  total_pages: number;
  total_count: number;
  messages?: Messages[];
  page: number;
  hasMoreMessages: boolean;
  messagesByDate: Record<string, Messages[]>;
  currentTaskId: number;
  messagesMap: Map<number, Messages[]>;

  constructor() {
    this.ChatAPI = new ChatAPI();
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;
    this.messages = [];
    this.page = 1;
    this.hasMoreMessages = true;
    this.messagesByDate = {};
    this.currentTaskId = 0;
    this.messagesMap = new Map<number, Messages[]>();

    makeObservable(this, {
      //   messages: observable,
      messagesMap: observable,
      hasMoreMessages: observable,
      messagesByDate: observable,
      groupMessagesByDate: action,
      getTaskMessages: action,
      addMessage: action,
      resetMessages: action,
      setTaskId: action,
    });
  }

  groupMessagesByDate() {
    this.messagesByDate = {};
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const messages = this.messagesMap.get(this.currentTaskId) || [];
    if (messages) {
      messages.forEach((message) => {
        const messageDate = new Date(message.created_date!);
        let dateKey: string;

        if (messageDate.toDateString() === today.toDateString()) {
          dateKey = "Today";
        } else if (messageDate.toDateString() === yesterday.toDateString()) {
          dateKey = "Yesterday";
        } else {
          dateKey = messageDate.toLocaleDateString();
        }

        if (!this.messagesByDate[dateKey]) {
          this.messagesByDate[dateKey] = [];
        }
        this.messagesByDate[dateKey].push(message);
      });
    }
  }

  setTaskId = (taskId: number) => {
    this.currentTaskId = taskId;
  };

  resetMessages() {
    this.messages = [];
    this.messagesByDate = {};
    this.groupMessagesByDate();
    this.page = 1;
    this.hasMoreMessages = true;
  }

  getTaskMessages = async (params: {
    taskId: number;
    page?: number;
    lastMessageId?: number;
  }) => {
    try {
      params.taskId = this.currentTaskId;
      if (params.page === 1) {
        this.resetMessages();
        const currentList = this.messagesMap.get(params.taskId) || [];
        if (currentList.length === 0) {
          const response = await this.ChatAPI.getTaskMessages(params);
          this.messagesMap.set(params.taskId, response.list.reverse());
        } else {
          const newList = await this.ChatAPI.getTaskMessagesAfterLastMessage({
            ...params,
            lastMessageId: currentList[currentList.length - 1].id,
          });
          this.messagesMap.set(params.taskId, [...currentList, ...newList]);
        }
      } else {
        const response = await this.ChatAPI.getTaskMessages(params);
        const currentList = this.messagesMap.get(params.taskId) || [];
        this.messagesMap.set(params.taskId, [
          ...response.list.reverse(),
          ...currentList,
        ]);
      }

      //   this.limit = response.limit;
      //   this.total_pages = response.total_pages;
      //   this.total_count = response.total_count;

      //   this.hasMoreMessages = this.total_count > this.messages.length;

      this.groupMessagesByDate();
    } catch (error: any) {
      throw error;
    }
  };

  addMessage = async (
    params: { task_id: number; message: string },
    newMessage: Messages
  ) => {
    try {
      const response = await this.ChatAPI.addMessage(params);
      if (response.result) {
        const currentList = this.messagesMap.get(params.task_id) || [];
        const updatedMessage = {
          ...newMessage,
          id: response.result!,
        };
        currentList.push(updatedMessage);
        this.messagesMap.set(params.task_id, [...currentList]);
        this.groupMessagesByDate();
      }
    } catch (error: any) {
      throw error;
    }
  };
}
